module.exports = __webpack_public_path__ + "media/images/top/icon/white/ico_pause-34de7b25766778c93c7de48d8d4f0b66.svg";